import Heading from "../UI/Heading";
import Text from "../UI/Text";

import { Link } from "react-router-dom";
import styles from "./styles.module.scss";
import Button from "../UI/Button";
import { useIsHeadOfDept } from "../../shared/hooks";
import { enums } from "../../shared";
import { CREATE_ASSESSMENT, ASSESSMENTS } from "../../shared/routes";
import { FormattedMessage } from "react-intl";
import plusCircleIcon from "../../assets/images/icons/plus-circle.svg";
import arrowLoop from "../../assets/images/icons/arrow-loop.svg";
import { Z_INDEX } from "../../shared/enums";

type WelcomeBoxProps = {
  firstName: string;
  isMobile?: boolean;
};

const WelcomeBox = ({ firstName, isMobile }: WelcomeBoxProps) => {
  const { MD, SM, XS } = enums.SIZE;
  const isHeadOfDept = useIsHeadOfDept();

  return !isMobile ? (
    <div className={styles.WelcomeBox}>
      <div className={styles["WelcomeBox-content"]}>
        <Heading
          sx={{
            marginBottom: "20px",
            maxWidth: isHeadOfDept ? "320px" : "",
            position: "relative",
            zIndex: Z_INDEX.FAB,
          }}
          size={MD}
        >
          <FormattedMessage
            id="dashboard.heading"
            values={{ name: firstName }}
          />
        </Heading>
        <div className={styles["WelcomeBox-content-arrowContainer"]}>
          <img src={arrowLoop} alt="arrow" />
        </div>
        <Heading color="gray" size={XS}>
          <FormattedMessage
            id={`dashboard.${isHeadOfDept ? "hodSubtitle" : "nonHodSubtitle"}`}
          />
        </Heading>
        <Text size={SM}>
          <FormattedMessage
            id={`dashboard.${
              isHeadOfDept ? "hodDescription" : "nonHodDescription"
            }`}
          />
        </Text>
      </div>
      <div>
        <Link to={isHeadOfDept ? CREATE_ASSESSMENT : ASSESSMENTS}>
          <Button
            iconFirst={isHeadOfDept}
            iconPath={isHeadOfDept ? plusCircleIcon : ""}
          >
            <FormattedMessage
              id={`dashboard.${isHeadOfDept ? "hodCta" : "nonHodCta"}`}
            />
          </Button>
        </Link>
      </div>
    </div>
  ) : (
    <div className={styles.WelcomeBox}>
      <div className={styles["WelcomeBox-content"]}>
        <Heading
          sx={{
            marginBottom: "15px",
            position: "relative",
            zIndex: Z_INDEX.FAB,
          }}
          size={MD}
        >
          <FormattedMessage
            id="dashboard.heading"
            values={{ name: firstName }}
          />
        </Heading>
        <Link to={ASSESSMENTS}>
          <Button>
            <FormattedMessage id={"dashboard.nonHodCta"} />
          </Button>
        </Link>
        <Text size={MD} noMargin sx={{ marginTop: "5px" }} isBold textCenter>
          <FormattedMessage id={"dashboard.nonHodSubtitle"} />
        </Text>
        <Text size={MD} textCenter>
          <FormattedMessage id={"dashboard.nonHodDescription"} />
        </Text>
      </div>
    </div>
  );
};

export default WelcomeBox;
